import { render, staticRenderFns } from "./AddServer.vue?vue&type=template&id=7d7bdb3f&scoped=true&"
import script from "./AddServer.vue?vue&type=script&lang=js&"
export * from "./AddServer.vue?vue&type=script&lang=js&"
import style0 from "./AddServer.vue?vue&type=style&index=0&id=7d7bdb3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7bdb3f",
  null
  
)

export default component.exports